import { initials } from "./LeaderboardRow";

const GOLD = "#C9A24B";
const GREEN = "#b4c540";

// Renders an empty slot of the same width when the company has fewer than
// three ranked agents, so the podium keeps its 2-1-3 shape.
const Pillar = ({ entry, place }) => {
  const isFirst = place === 1;
  const size = isFirst ? 96 : 68;

  if (!entry) return <div style={{ width: size }} className="mx-2" />;

  return (
    <div className="mx-2 flex flex-col items-center">
      <div
        className="flex items-center justify-center rounded-full"
        style={{
          width: size,
          height: size,
          backgroundColor: "#e9e9e9",
          border: `${isFirst ? 3 : 2}px solid ${isFirst ? GOLD : GREEN}`,
        }}
      >
        {isFirst ? (
          <span style={{ fontSize: 40 }}>🏆</span>
        ) : (
          <span className="font-bold text-secondary">{initials(entry.name)}</span>
        )}
      </div>
      <div className="mt-1 max-w-[120px] truncate text-sm text-black">
        {place} · {entry.name?.split(" ")[0]}
      </div>
      <div className="font-bold text-black">{entry.count}</div>
    </div>
  );
};

const Podium = ({ top = [] }) => (
  <div className="flex items-end justify-center px-6 py-6">
    <Pillar entry={top[1]} place={2} />
    <Pillar entry={top[0]} place={1} />
    <Pillar entry={top[2]} place={3} />
  </div>
);

export default Podium;
